module.exports = __webpack_public_path__ + "static/media/01.ab03e0f7.jpg";